import script from "./LedgerSettingsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LedgerSettingsView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__